import './Fail.less';
export { default as Fail } from './Fail.js';
export { default } from './Fail.js';